<template>
  <div>
    <BaseTitle :title="$t(!editable ? 'content.user_view' : edit ? 'content.user_edit' : 'content.user_create')" />
    <v-row>
      <v-col cols="12" md="auto" style="width: 330px">
        <v-card>
          <div class="pa-8 mb-4">
            <div v-if="showPhoto">
              <div class="app-section-title">{{ $t('content.user_upload_title') }}</div>
              <form-group :name="$t('form.image')" :validator="$v.form.image" no-gutter>
                <template slot-scope="{ attrs }">
                  <image-box
                    v-model="form.image"
                    v-bind="attrs"
                    :with-upload="editable && form.primarySchoolAdmin == false"
                    :upload-btn-text="$t(edit ? 'change_photo' : 'upload')"
                    :image-preview="imageUrl"
                    @change="$v.form.image.$touch()"
                    class="mt-4"
                  />
                </template>
              </form-group>
            </div>
            <v-btn
              color="primary"
              block
              class="btn-primary-custom"
              v-if="!showPhoto"
              :disabled="form.primarySchoolAdmin || !editable"
              @click="togglePhoto"
            >
              {{ $t('content.add_photo') }}
            </v-btn>
          </div>
        </v-card>

        <v-card>
          <div class="px-8 py-3" style="background-color:#00BF63; color:#FFFFFF;">
            Role User
          </div>
          <div class="px-8 py-4" style="color:#6D6D6D;">
            <b>{{ roleName }}</b>
          </div>
        </v-card>
        <br />
        <v-card>
          <div class="px-8 py-4">
            <form-group :name="$t('form.status')" :validator="$v.form.status">
              <template slot-scope="{ attrs }">
                <v-select
                  :items="status"
                  :disabled="form.primarySchoolAdmin == true || form.primaryMasterAdmin == true || !editable"
                  :label="$t('form.status')"
                  v-bind="attrs"
                  v-model="form.status"
                  width="100"
                >
                  <template #item="{item}">
                    {{ $t(item.text) }}
                  </template>
                  <template #selection="{item}">
                    {{ $t(item.text) }}
                  </template>
                </v-select>
              </template>
            </form-group>
          </div>
        </v-card>

        <br />
        <v-card v-if="form.storage">
          <div class="px-8 py-3" style="background-color:#00BF63; color:#FFFFFF;">
            {{ $t('content.storage') }}
          </div>
          <div class="px-8 py-4">
            <v-row no-gutters class="mb-2">
              <v-col md="12" class="d-flex justify-space-between">
                <span class="body-content"
                  >{{ form.storage ? form.storage.storageUsed : 0 }} MB of {{ form.storage ? form.storage.totalStorage : 0 }} MB used</span
                >
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col md="12">
                <v-progress-linear
                  :color="'#00BF63'"
                  height="14"
                  background-color="#E3E3E3"
                  :value="form.storage ? form.storage.percentage : 0"
                  style="border-radius: 9px;"
                >
                </v-progress-linear>
              </v-col>
            </v-row>
          </div>
        </v-card>
        <br />
        <v-card>
          <div class="px-8 py-3" style="background-color:#00BF63; color:#FFFFFF;">
            {{ $t('content.last_activity') }}
          </div>
          <div class="px-8 py-4" style="color:#6D6D6D;">
            <strong v-if="form.lastActivity > 0">{{ form.lastActivity }} {{ $t('content.day_ago') }}</strong>
            <strong v-if="form.lastActivity === '0'">{{ $t('content.today') }}</strong>
            <strong v-if="form.lastActivity === '-'">{{ $t('content.not_login') }}</strong>
          </div>
        </v-card>
        <br />
      </v-col>
      <v-col>
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <div class="app-section-title">{{ $t('form.personal_information') }}</div>
              <form-group :name="$t('form.first_name')" :validator="$v.form.firstName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.firstName"
                    v-bind="attrs"
                    disabled
                    :label="$t('form.first_name')"
                    @input="$v.form.firstName.$touch()"
                    @blur="$v.form.firstName.$touch()"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.last_name')" :validator="$v.form.lastName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.lastName"
                    v-bind="attrs"
                    disabled
                    :label="$t('form.last_name')"
                    @input="$v.form.lastName.$touch()"
                    @blur="$v.form.lastName.$touch()"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.gender')" :validator="$v.form.gender">
                <template slot-scope="{ attrs }">
                  <v-select :items="gender" :label="$t('form.gender')" disabled v-bind="attrs" v-model="form.gender">
                    <template #item="{item}">
                      {{ $t(item.text) }}
                    </template>
                    <template #selection="{item}">
                      {{ $t(item.text) }}
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('form.place_of_birth')" :validator="$v.form.placeOfBirth">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.placeOfBirth"
                    v-bind="attrs"
                    disabled
                    :label="$t('form.place_of_birth')"
                    @input="$v.form.placeOfBirth.$touch()"
                    @blur="$v.form.placeOfBirth.$touch()"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.date_of_birth')" :validator="$v.form.dateOfBirth">
                <template slot-scope="{ attrs }">
                  <v-menu
                    ref="menuFrom"
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    :return-value.sync="menuFrom"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs:attrActivator }">
                      <v-text-field
                        v-model="form.dateOfBirth"
                        :label="$t('form.date_of_birth')"
                        disabled
                        readonly
                        v-bind="{ ...attrActivator, ...attrs }"
                        v-on="on"
                      >
                        <template #append>
                          <svg-icon icon="calendar" class="primary--text mr-3" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.dateOfBirth" :max="datemaxcurrent" :locale="$i18n.locale">
                      <v-spacer />
                      <v-btn text color="primary" @click="menuFrom = false">{{ $t('cancel') }}</v-btn>
                      <v-btn text color="primary" @click="$refs.menuFrom.save(form.dateOfBirth)">{{ $t('ok') }}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </template>
              </form-group>
              <form-group :name="$t('form.email')" :validator="$v.form.email">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.email"
                    v-bind="attrs"
                    disabled
                    :label="$t('form.email')"
                    @input="$v.form.email.$touch()"
                    @blur="$v.form.email.$touch()"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.phone_number')" :validator="$v.form.phoneNumber">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.phoneNumber"
                    v-bind="attrs"
                    v-phone
                    disabled
                    :label="$t('form.phone_number')"
                    @input="$v.form.phoneNumber.$touch()"
                    @blur="$v.form.phoneNumber.$touch()"
                  />
                </template>
              </form-group>

              <div class="app-section-title">{{ $t('form.address_information') }}</div>
              <form-group :name="$t('form.address')" :validator="$v.form.address">
                <template slot-scope="{ attrs }">
                  <v-textarea
                    v-model="form.address"
                    v-bind="attrs"
                    disabled
                    :label="$t('form.address')"
                    @input="$v.form.address.$touch()"
                    @blur="$v.form.address.$touch()"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.province')" :validator="$v.form.provinceId">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="provinces"
                    :loading="loadingProvinces"
                    :label="$t('province')"
                    disabled
                    item-value="provinceId"
                    item-text="name"
                    v-bind="attrs"
                    v-model="form.provinceId"
                    @change="getCities"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.city')" :validator="$v.form.cityId">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="cities"
                    :loading="loadingCities"
                    :label="$t('city')"
                    disabled
                    item-value="cityId"
                    item-text="name"
                    v-bind="attrs"
                    v-model="form.cityId"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.postal_code')" :validator="$v.form.postalCode">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    minlength="5"
                    maxlength="5"
                    v-model.number="form.postalCode"
                    v-bind="attrs"
                    v-number
                    disabled
                    :label="$t('form.postal_code')"
                    @input="$v.form.postalCode.$touch()"
                    @blur="$v.form.postalCode.$touch()"
                  />
                </template>
              </form-group>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
            <v-btn v-if="editable" color="primary" :loading="loading" class="btn-primary-custom" type="submit">
              {{ $t(edit ? 'save' : 'submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import BaseTitle from '@/components/base/Title';
import ImageBox from '@/components/ImageBox';

export default {
  name: 'MasterUserCreateEdit',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BaseTitle,
    ImageBox
  },
  computed: {
    ...mapGetters({
      status: 'Reference/itemStatus',
      provinces: 'Reference/itemProvinces',
      gender: 'Reference/itemGender'
    }),
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities']();
      }
    },
    roleName() {
      let roleName = {
        1: 'Master Administrator',
        2: 'School Administrator',
        3: 'Parents',
        4: 'Teacher',
        5: 'Student'
      };
      return roleName?.[this.form.roleId];
    }
  },
  validations: function() {
    return {
      form: {
        status: { required }
      }
    };
  },
  data: () => ({
    form: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      storage: {},
      lastActivity: '',
      gender: '',
      address: '',
      status: true,
      placeOfBirth: '',
      provinceId: null,
      dateOfBirth: '',
      cityId: '',
      postalCode: '',
      roleId: 1,
      schoolId: '',
      image: null,
      primarySchoolAdmin: '',
      primaryMasterAdmin: ''
    },
    showPhoto: false,
    edit: false,
    validationName: 'dynamic',
    datemaxcurrent: new Date().toISOString().split('T')[0],
    imageUrl: null,
    menuFrom: false,
    loading: false,
    hasLoad: false,
    loadingProvinces: false,
    loadingCities: false
  }),
  methods: {
    getData() {
      this.$store.dispatch('UserLite/fetchDetail', this.$route.params.id).then(res => {
        // Object.keys(this.form).forEach(form => (this.form[form] = res[form]));
        Object.keys(this.form).forEach(form => {
          this.form[form] = res[form];
        });
        this.form.image = null;
        if (res.imageUrl) {
          this.imageUrl = res.imageUrl;
          this.showPhoto = true;
        }
        this.getCities();
        this.hasLoad = true;
      });
    },
    getProvinces() {
      this.loadingProvinces = true;
      this.$store.dispatch('Reference/fetchProvinces').finally(() => (this.loadingProvinces = false));
    },
    getCities() {
      if (this.hasLoad) {
        this.form.cityId = null;
      }
      this.loadingCities = true;
      this.$store.dispatch('Reference/fetchCities', this.form.provinceId).finally(() => (this.loadingCities = false));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), status: this.form.status };
      this.$store
        .dispatch(`UserLite/update`, payload)
        .then(() => this.$router.push({ name: this.edit ? 'UserLiteUpdateSuccess' : 'UserLiteUpdateSuccess' }))
        .finally(() => (this.loading = false));
    },
    backToList() {
      this.$router.push({ name: 'MasterUserLite' });
    },
    preventNav(event) {
      if (!this.edit || !this.$v.$anyDirty) return;
      event.preventDefault();
      event.returnValue = '';
    },
    togglePhoto() {
      this.showPhoto = !this.showPhoto;
    }
  },
  created() {
    this.$store.commit('Reference/RESET_CITIES');
    this.getProvinces();

    if (this.$route.params.id) {
      this.edit = true;
      this.getData();
    } else {
      this.hasLoad = true;
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('beforeunload', this.preventNav));
  },
  beforeRouteLeave(to, from, next) {
    if (!this.edit && this.$v.$anyDirty && this.$v.$invalid) {
      if (!window.confirm(this.$t('alert.leave_message'))) {
        return;
      }
    }
    next();
  }
};
</script>
